import { BASE_URL_CHART, BASE_URL_LOGO } from '@/constants';
import { CryptoType } from '@/hooks/useGetCrypto';
import numberUtils from '@/utils/numberUtils';
import map from 'lodash/map';

export default (list: CryptoType[]) => {
  const newList = map(list || [], item => {
    const base = item.base.toLowerCase();
    return {
      ...item,
      chartUrl: `${BASE_URL_CHART}/${base === 'usdt' ? 'usdc' : base}usdt.svg`,
      logoUrl: `${BASE_URL_LOGO}/${base.toUpperCase()}.svg`,
      otc: item.otc
        ? {
            ...item.otc,
            price: `${numberUtils.delimiter(item.otc.price)}`,
            sellPrice: `${numberUtils.delimiter(item.otc.sellPrice)}`,
            buyPrice: `${numberUtils.delimiter(item.otc.buyPrice)}`,
            midPrice: `${numberUtils.delimiter(
              new numberUtils.bigDecimal(
                (Number(item.otc.sellPrice) + Number(item.otc.buyPrice)) / 2
              ).getValue()
            )}`
          }
        : undefined,
      p2p: item.p2p
        ? {
            ...item.p2p,
            price: `${numberUtils.delimiter(item.p2p.price)}`
          }
        : undefined
    };
  });
  return newList;
};
